module.exports = __webpack_public_path__ + "front/img/i8.3c128e5c.png";